const throttle = (func: Function, timeFrame: number) => {
	let lastTime = 0;
	let trailing: ReturnType<typeof setTimeout> | undefined;
	/* eslint-disable @typescript-eslint/no-explicit-any */
	const throttled = (...args: Array<any>) => {
		const now = new Date().getTime();
		clearTimeout(trailing);
		if (now - lastTime >= timeFrame) {
			func(...args);
			lastTime = now;
			return;
		}
		// Without a trailing call, the last event in a burst (e.g. the final
		// width of a window drag) is dropped and state stays stale.
		trailing = setTimeout(
			() => {
				func(...args);
				lastTime = new Date().getTime();
			},
			timeFrame - (now - lastTime),
		);
	};
	return Object.assign(throttled, { cancel: () => clearTimeout(trailing) });
};

export default throttle;
